import { type ReactNode } from 'react';
import { type FormQuestion } from '../data/questions';
import { cn } from '@/utils/cn';
import { QuestionHeader } from './question-header';

type Props = {
  question: FormQuestion;
  selected: string | null;
  onSelect: (answer: 'a' | 'b' | 'c') => void;
  stepper?: ReactNode;
};

const KEYS = ['a', 'b', 'c'] as const;

export function QuestionCard({
  question,
  selected,
  onSelect,
  stepper,
}: Props): ReactNode {
  return (
    <div className="space-y-md">
      <QuestionHeader question={question} stepper={stepper} />
      <div className="space-y-sm">
        {KEYS.map((key) => (
          <OptionButton
            key={key}
            label={`${key.toUpperCase()}) ${question.options[key]}`}
            active={selected === key}
            onClick={() => onSelect(key)}
          />
        ))}
      </div>
    </div>
  );
}

export function OptionButton({
  label,
  active,
  onClick,
}: {
  label: string;
  active: boolean;
  onClick: () => void;
}): ReactNode {
  return (
    <button
      onClick={onClick}
      className={cn(
        'w-full rounded-lg border px-md py-sm text-left text-sm transition-all',
        active
          ? 'border-brand-red/50 bg-brand-red/10 backdrop-blur-xl text-text-primary'
          : 'border-white/[0.08] bg-white/[0.05] backdrop-blur-xl text-text-secondary hover:border-white/[0.15]'
      )}
    >
      {label}
    </button>
  );
}
